import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { DogBaseSearch, DogOwnerApi, PersonGridDto } from "../../../../../../api";
import { CustomDataTable } from "../../../../../../components";
import { useGlobalData } from "../../../../../../contexts";
import { useApiService, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import { generateAddress } from "../../../../../../utils";

export interface IDogCurrentOwnerSelectionPanelProps {
  onPersonSelected: (personId: number) => void;
  dogId: number;
}

export const DogCurrentOwnerSelectionPanel: React.FunctionComponent<IDogCurrentOwnerSelectionPanelProps> = (props) => {
  const api = useApiService(DogOwnerApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
  });

  const searchFunction = React.useCallback(
    (sObj?: DogBaseSearch) =>
      api.baseSearch(
        DogBaseSearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
          dogId: props.dogId,
          currentOwners: true,
        })
      ),
    [api, currentLanguage.languageId, props.dogId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: PersonGridDto) => (
          <ButtonContainer>
            <Button
              onClick={() => {
                props.onPersonSelected(row.personId);
              }}
              text={t(ETLCodes.Select)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "computedName",
      },
      {
        header: () => t(ETLCodes.Address),
        fieldName: "address",
        render: (row: PersonGridDto) => generateAddress(row.number, row.street, row.city, row.postalCode, row.country),
      },
    ],
    [props, t]
  );
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <CustomDataTable
      tableState={tableState}
      loading={loading}
      columns={columns}
      filterMode="OnEnter"
      focusOnFilter={true}
    />
  );
};
